export type JsonValue = null | boolean | number | string | readonly JsonValue[] | { readonly [key: string]: JsonValue };
export type JsonSchemaObject = { readonly [key: string]: JsonValue };

const UUID_PATTERN = "^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$";

/** `format: uuid` documents intent; the explicit pattern pins ajv to the same set zod accepts (no `urn:uuid:` prefix). */
export const JSON_SCHEMA_UUID: JsonSchemaObject = { type: "string", format: "uuid", pattern: UUID_PATTERN };

/** JSON Schema patterns have no case-insensitive flag, so literal words are expanded into character classes. */
export const caseInsensitivePattern = (word: string): string => [...word].map((char) => (/[a-z]/iu.test(char) ? `[${char.toLowerCase()}${char.toUpperCase()}]` : char)).join("");
